import React from "react";
import HomeIcon from "@material-ui/icons/Home";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import GroupIcon from "@material-ui/icons/Group";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

export const staticMenu = [
  {
    id: 1,
    menuName: "Home",
    menuDescription: "Home",
    path: "/welcome",
    exact: true,
    icon: <HomeIcon />,
    tooltip: "Home",
    submenu: [],
  },
  {
    id: 2,
    menuName: "Management",
    menuDescription: "User Register",
    tooltip: "Management",
    exact: true,
    icon: <AccessibilityIcon />,
    submenu: [
      {
        id: 1,
        menuName: "Register",
        menuDescription: "To Setup sub departments",
        path: "/register",
        tooltip: "Register",
        icon: <PersonAddIcon />,
      },
      {
        id: 2,
        menuName: "View Users",
        menuDescription: "To Setup sub departments",
        path: "/all_users",
        tooltip: "View Users",
        icon: <GroupIcon />,
      },
    ],
  },
];
